import React from 'react';
import {TableBody, TableRow, TableCell} from "material-ui/Table";
import TableRolesPermissionsInputs from './TableRolesPermissionsInputs';

const TableGroupedPermissions = ({classes, group, groupPerms, rolesPermissions, roles, changeRolePermission}) => (
    <TableBody>
        <TableRow className={classes.groupRows}>
            <TableCell colSpan={roles.length + 1} className={classes.tableCell}>
                <div>{group.group_name}</div>
            </TableCell>
        </TableRow>
        {groupPerms.map(perm => {
            return (
                <TableRolesPermissionsInputs
                    key={'permission-' + perm.id}
                    perm={perm}
                    rolesPermissions={rolesPermissions}
                    classes={classes}
                    changeRolePermission={changeRolePermission}
                    roles={roles}
                />
            )
        })}
    </TableBody>
)

export default TableGroupedPermissions;


// WEBPACK FOOTER //
// ./src/containers/roles/forms/TableGroupedPermissions.jsx